import { Button } from 'antd'
import LabBunkerSection from './LabBunkerSection'
import LabDifferenceSection from './LabDifferenceSection'
import LabHLVesselSection from './LabHLVesselSection'
import LabQuantitySection from './LabQuantitySection'
import LabRemarksSection from './LabRemarksSection'
import LabSampleSealsSection from './LabSampleSealsSection'
import LabSurveyLogSection from './LabSurveyLogSection'
import LabTestSection from './LabTestSection'

import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import './laboratorySection.less'

const LaboratorySection = () => {
  const { t } = useTranslation()
  const { trigger } = useFormContext()
  const [saveAttempted, setSaveAttempted] = useState(false)

  const handleSaveClick = async () => {
    setSaveAttempted(true)
    await trigger('laboratory')
  }

  return (
    <div className="lab-section">
      <div className="lab-section__layout">
        {/* Left panel: Bunker col + Survey Log col, then stacked sections */}
        <div className="lab-section__left-panel">
          {/* Top row: Bunker | Survey Log */}
          <div className="lab-section__top-row">
            <div className="lab-section__bunker-col">
              <LabBunkerSection saveAttempted={saveAttempted} />
            </div>
            <div className="lab-section__survey-col">
              <LabSurveyLogSection />
            </div>
          </div>

          {/* Sample Seals */}
          <LabSampleSealsSection />

          {/* BDR / BBM / Quantity as Supplied */}
          <LabQuantitySection />

          {/* Difference: Surveyor vs Suppliers Figures */}
          <LabDifferenceSection />

          {/* HL Vessel Tanks Measurements */}
          <LabHLVesselSection />
        </div>

        {/* Right panel: Test + Remarks + Actions */}
        <div className="lab-section__right-panel">
          {/* Test section */}
          <LabTestSection saveAttempted={saveAttempted} />

          {/* Remarks */}
          <LabRemarksSection />

          {/* Actions */}
          <div className="lab-section__actions">
            <Button htmlType="button" onClick={handleSaveClick} type="primary">
              {t('rob.survey.bunker.lab.remarks.saveButton')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LaboratorySection
